__turbopack_context__.v({
  "calculator-input-row": "calculator-usage-input-module-scss-module__pAUHNG__calculator-input-row",
  "calculator-usage-input": "calculator-usage-input-module-scss-module__pAUHNG__calculator-usage-input",
  "calculator-usage-input-error": "calculator-usage-input-module-scss-module__pAUHNG__calculator-usage-input-error",
  "modal-content": "calculator-usage-input-module-scss-module__pAUHNG__modal-content",
  "placeholder": "calculator-usage-input-module-scss-module__pAUHNG__placeholder",
});
